import { PaginatorDesignTokens } from '@primeuix/themes/types/paginator';

export const Paginator: PaginatorDesignTokens = {
  colorScheme: {
    light: {
      root: {
        background: '{surface.50}'
      },
      navButton: {
        hoverBackground: '{primary.100}',
      }
    }
  }
}
